import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { Page404 } from '../pages/Page404'
import { ListJobs } from '../pages'
import { Success } from '../pages/Success'
import { ListJobsAdmin } from '../pages/ListJobsAdmin'
import { NewJob } from '../pages/NewJob'
import { EditJob } from '../pages/EditJob'
import { ViewJob } from '../pages/ViewJob'

export const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={ListJobs} />
        <Route exact path="/admin" component={ListJobsAdmin} />
        <Route exact path="/admin/nova-vaga" component={NewJob} />
        <Route exact path="/admin/editar-vaga/:id" component={EditJob} />
        <Route exact path="/detalhes-vaga/:id" component={ViewJob} />
        <Route exact path="/curriculo-enviado" component={Success} />
        <Route path="*" component={Page404} />
      </Switch>
    </BrowserRouter>
  )
}
